export default "__VITE_ASSET__CeNTfObN__"